<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Kas Mutasi</h5>
            </template>
            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row class="align-items-start justify-content-between">
                    <b-col md="12" lg="9">
                        <b-row>
                            <b-col >
                                <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Request">
                                    <div class="d-flex align-items-center search-input-wrapper">
                                        <b-form-input
                                            v-model="input.filterFromDate" name="filterFromDate"
                                            id="filterDate"
                                            type="date"
                                        ></b-form-input>
                                        <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                        <b-form-input 
                                            v-model="input.filterToDate" name="filterToDate"
                                            type="date"
                                        ></b-form-input>
                                    </div>
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterCabang" label="Dari Cabang">
                                    <multiselect
                                        name="dariCabang"
                                        v-model="input.filterDariCabang" 
                                        :options="dariCabangOption" 
                                        :internal-search="true"
                                        :allow-empty="true"
                                        deselect-label=""
                                        select-label=""
                                        label="name"
                                        track-by="name"
                                        placeholder="-- Pilih Cabang Sumber --"
                                    />
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterCabang" label="Tujuan Cabang">
                                    <multiselect
                                        name="tujuanCabang"
                                        v-model="input.filterKeCabang" 
                                        :options="keCabangOption" 
                                        :internal-search="true"
                                        :allow-empty="true"
                                        deselect-label=""
                                        select-label=""
                                        label="name"
                                        track-by="name"
                                        placeholder="-- Pilih Cabang Tujuan --"
                                    />
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                                    <b-form-select v-model="input.filterStatus" name="statusKasMutasi" :options="status" value-field="id" text-field="name">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>-- Pilih status --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <div class="filter-btn-wrapper">
                                    <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                        Search
                                    </b-button>
                                    <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="text-right mt-3">
                        <div>
                            <b-button v-if="enableInputHO" class="mb-3" variant="pgiBtn" @click="inputKasMutasiHo" name="kasMutasiHoAddBtn">Input Kas Mutasi HO</b-button>
                        </div>
                        <div>
                            <b-button v-if="enableInputHO" class="mb-3" variant="pgiBtn" @click="penerimaanKasPusat" name="kasMutasiHoAddBtn">Penerimaan Kas Pusat</b-button>
                        </div>
                        <div>
                            <b-button v-if="enableInput" class="mb-3" variant="pgiBtn" @click="inputKasMutasi" name="kasMutasiAddBtn">Input Kas Mutasi</b-button>
                        </div>
                    </b-col>
                </b-row>
                
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="kasMutasi" 
                :fields="fields"
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data kas mutasi.
                </template>
                <template v-slot:cell(nominal)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominal !== null">Rp. {{$helper.addThousandSeparator(row.item.nominal)}} </div>
                    <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominal)}} </div>
                </template>
                <template v-slot:cell(tanggalPembuatan)="row">
                    <div>{{$helper.changeDateFormat(row.item.tanggalPembuatan)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalPembuatan)}}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status.id == 1">{{ row.item.status.name }}</b-badge>
                    <b-badge variant="primary" v-else-if="row.item.status.id == 2">{{ row.item.status.name }}</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status.id == 3">{{ row.item.status.name }}</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status.id == 4">{{ row.item.status.name }}</b-badge>
                    <b-badge v-else>{{ row.item.status.name }}</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="kasMutasiDetailBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Kas mutasi masih menunggu cabang pengirim "Dari" untuk melakukan pengiriman.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">TERKIRIM</h6>
                <p class="smallText mb-0">Kas mutasi sudah dikirimkan dari cabang pengirim "Dari".</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Kas mutasi sudah diterima oleh cabang penerima. Kas cabang pengirim dan penerima sudah disesuaikan sesuai dengan nominal mutasi.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">BATAL</h6>
                <p class="smallText mb-0">Kas mutasi sudah dibatalkan dan tidak dapat diproses lagi.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'kas-mutasi',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            role: null,
            credential: null,
            input:{
                show: 10,
                filterFromDate: null,
                filterToDate: null,
                filterStatus: null,
                filterDariCabang: null,
                filterKeCabang: null,
                sortBy: null,
                sortDesc: null
            },
            fields: [
                { key: "dari.name", label: "Dari" },
                { key: "tujuan.name", label: "Ke" },
                { key: "createdBy.name", label: "Dibuat oleh" },
                { key: "nominal", label: "Nominal" },
                { key: "tanggalPembuatan", label: "Tanggal" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            status: [ 
                { id: 1, name: 'Pending' },
                { id: 2, name: 'Terkirim' },
                { id: 3, name: 'Diterima'},
                { id: 4, name: 'Batal'}
            ],
            dariCabangOption: [],
            keCabangOption: [],
            kasMutasi: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: "",
            enableInputHO: false,
            enableInput: false,
        }
    }, 
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.role = localStorage.role

            this.$axios.get("/cabang/kas/input-allowed").then(response => {
                this.credential = response.data
                if (this.credential.id == 1) this.enableInputHO = true
                else if (this.credential.id == 0) this.enableInput = true
            })

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.dariCabangOption.push(element)
                        this.keCabangOption.push(element)
                })
            })

            let getKasMutasi = this.$axios.get("cabang/kas/mutasi/"+this.query).then(response => {
                this.kasMutasi = response.data.data
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getCabang, getKasMutasi]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Kas Mutasi -----------------

        getKasMutasi(){
            this.toggleBusy()
            this.kasMutasi = []

            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEndDate=" + this.input.filterToDate
            if (this.input.filterDariCabang != null) this.query = this.query + "&filterDari=" + this.input.filterDariCabang.id
            if (this.input.filterKeCabang != null) this.query = this.query + "&filterTujuan=" + this.input.filterKeCabang.id
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc
            
            this.$axios.get("cabang/kas/mutasi/"+this.query).then(response => {
                this.kasMutasi = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getKasMutasi()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getKasMutasi()
            }
        },

        onReset(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.input.filterStatus = null
            this.input.filterDariCabang = null
            this.input.filterKeCabang = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getKasMutasi()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getKasMutasi()
            }
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputKasMutasi(){
            this.$router.push({path: `${this.$route.path}/input`});
        },

        inputKasMutasiHo(){
            this.$router.push({path: `${this.$route.path}/inputho`});
        },

        penerimaanKasPusat(){
            this.$router.push({path: `${this.$route.path}/penerimaanKasPusat`});
        }

    },
    created(){
        this.init()
    }
}
</script>
